import React, { FC, useContext } from 'react';
import { Box, FormGroup, useMediaQuery, useTheme } from '@mui/material';
import CustomRating from '../CustomRating/CustomRating';
import { useTranslation } from 'react-i18next';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';

interface Props {
  question: any;
  step: number;
  customFont?: string;
  onChange: (qid: string, val: string, i: number, p: boolean) => Promise<void>;
  value?: string;
}

const CustomQuestionScalenps: FC<Props> = ({ question, step, onChange, customFont }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation();
  const t = localContext ? localContext.t : globalT;

  let highText = t('nps_high');
  let lowText = t('nps_low');

  if (question.options && question.options.length == 2) {
    highText = question.options[1].label;
    lowText = question.options[0].label;
  }

  return (
    <Box>
      <FormGroup>
        <CustomRating
          highText={highText}
          lowText={lowText}
          min={0}
          max={10}
          font={customFont ?? ''}
          isSmallScreen={isSmallScreen}
          onRatingClick={async (rating) => {
            await onChange(question.questionId || '', '' + rating, step, false);
          }}
          currentRating={-1}
        />
      </FormGroup>
    </Box>
  );
};

export default CustomQuestionScalenps;
